import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { BisualSetting } from 'src/app/models/bisual-setting.model';
import { ApiService } from 'src/app/services/api.service';
import { MatButton } from '@angular/material/button';

import { MatFormField, MatHint } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { FormsModule } from '@angular/forms';
import { BisualSettingSectionKeyToTitlePipe } from '../../../../../pipes/bisual-setting-section-key-to-title.pipe';

@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatButton, MatFormField, MatInput, MatSlideToggle, FormsModule, MatHint, BisualSettingSectionKeyToTitlePipe],
})
export class ConfigurationComponent implements OnInit {
  private api = inject(ApiService);

  protected readonly page_title = inject(ActivatedRoute).snapshot.title;

  settings: SettingStructureRow[] = [];
  save_disabled: boolean = true;

  ngOnInit(): void {
    this.fetchSettings();
  }

  save() {
    const data = this.loadApiToUploadToApi();
    this.api.updateBulkBisualSettings(data).subscribe(data => {
      this.markAllAsNotEdit();
      this.save_disabled = true;
    });
  }

  onInputChange(newVal: any, set: { setting: BisualSetting; edited: boolean }) {
    if (set.setting.value != newVal) {
      set.setting.value = newVal;
      set.edited = true;
      this.save_disabled = false;
    }
  }

  isBooleanSettingEnabled(value: unknown): boolean {
    return value === true || value === 'true' || value === 1 || value === '1';
  }

  onBooleanChange(checked: boolean, set: { setting: BisualSetting; edited: boolean }) {
    this.onInputChange(checked ? 'true' : 'false', set);
  }

  private fetchSettings() {
    this.api.getBisualSettings().subscribe(data => {
      const res: any = {};
      data.forEach(setting => {
        if (res[setting.section] == null) {
          res[setting.section] = {
            section: setting.section,
            settings: [],
          } as SettingStructureRow;
        }

        res[setting.section].settings.push({
          setting: setting,
          edited: false,
        });
      });

      this.settings = Object.values(res);
    });
  }

  private loadApiToUploadToApi() {
    return this.settings
      .map(item => item.settings)
      .flat()
      .filter(item => item.edited)
      .reduce(
        (result, values) => {
          if (values.setting?.key != null && values.setting.value !== undefined && values.setting.value !== null) {
            result[values.setting.key] = values.setting.value;
          }
          return result;
        },
        {} as { [key: string]: any }
      );
  }

  private markAllAsNotEdit() {
    for (const s of this.settings) {
      for (const set of s.settings) {
        if (set.edited) set.edited = false;
      }
    }
  }
}

interface SettingStructureRow {
  section: string;
  settings: {
    setting: BisualSetting;
    edited: boolean;
  }[];
}
